import Vue from "vue";
import VueRouter from "vue-router";
import VueMeta from "vue-meta";
import Home from "../views/Home.vue";
import firebase from "firebase/app";
import "firebase/auth";

Vue.use(VueRouter);
Vue.use(VueMeta);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      title: "Shox Adomokai — Developer | Strategist | Designer",
      about:
        "Home is where the heart it. Now that you are lost, it might be time to follow your heart"
    }
  },
  {
    path: "/404",
    name: "404 Error",
    component: () => import("../views/Error.vue"),
    meta: {
      hideFooter: true,
      hideScrollBar: true,
      title: "Error 404 - Missing Page",
      about:
        "The forbidden lands. No-one knows why but travellers who have lost their way end up here."
    }
  },
  {
    path: "/about",
    name: "About",
    component: () => import("../views/About.vue"),
    meta: {
      title: "About Me | Shox Adomokai",
      about:
        "Legend has it that this world is a simulation. Those who believe such tales record information about their creator on Sword mountain"
    }
  },
  {
    path: "/contact",
    name: "Contact",
    component: () => import("../views/Contact.vue"),
    meta: {
      title: "Contact Me | Shox Adomokai",
      about:
        "A ship sets sail to the outside world. Do you have a message you wish delivered? Tis best to give it to the captain to deliver for you"
    }
  },
  {
    path: "/infinite-daps",
    name: "Login",
    component: () => import("../views/Login.vue")
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: () => import("../views/Dashboard.vue"),
    meta: {
      requiresAuth: true,
      hideFooter: true
    }
  },
  {
    path: "/dashboard/gallery",
    name: "Admin Gallery",
    component: () => import("../views/GalleryDashboard.vue"),
    meta: {
      requiresAuth: true,
      hideFooter: true
    }
  },
  {
    path: "/dashboard/websites",
    name: "Admin Websites",
    component: () => import("../views/WebsiteDashboard.vue"),
    meta: {
      requiresAuth: true,
      hideFooter: true
    }
  },
  {
    path: "/dashboard/case-studies",
    name: "Admin Case Sudies",
    component: () => import("../views/CaseStudyDashboard.vue"),
    meta: {
      requiresAuth: true,
      hideFooter: true
    }
  },
  {
    path: "/projects",
    name: "Projects",
    component: () => import("../views/Projects.vue"),
    meta: {
      title: "Projects | A Collection of Designs and Websites",
      about:
        "The guards of the citadel keep watch over the treasures of the land. It is good to pay them visit, the decor is lovely"
    }
  },
  {
    path: "/case-studies",
    name: "Case Studies",
    component: () => import("../views/CaseStudy.vue"),
    meta: {
      hideShadow: true,
      hideFooter: true,
      hideScrollBar: true,
      title:
        "Case Studies | Digital Presentations of User Interface and Branding Studies",
      about:
        "A popular pilgrammage spot. Some believe the isle is merely a portal to another world! Up is left and right is down. A truly wonderful place"
    }
  },
  {
    path: "/case-studies/:slug",
    name: "Case Study",
    props: true,
    component: () => import("../views/Case.vue"),
    meta: {
      hideFooter: true,
      hideShadow: true,
      hideScrollBar: true
    }
  },
  {
    path: "/projects/designs",
    name: "Designs",
    props: true,
    component: () => import("../views/Designs.vue"),
    meta: {
      showSubMenu: true,
      title: "Designs | A Collection of Creative Designs",
      about:
        "A few years ago, our greatest artisans moved to this village to study the arts. They have taken to displaying some of their works routinely"
    }
  },
  {
    path: "/projects/websites",
    name: "Websites",
    props: true,
    component: () => import("../views/Websites.vue"),
    meta: {
      showSubMenu: true,
      title: "Websites | Collection of Interactive Websites",
      about:
        "There be spiders here. I do not like spiders but they weave pretty webs and some heroes greater than I go to explore them"
    }
  },
  {
    path: "*",
    redirect: "/404"
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return {
        x: 0,
        y: 0
      };
    }
  }
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth);
  const currentUser = firebase.auth().currentUser;

  if (requiresAuth && !currentUser) {
    next("/login");
  } else if (requiresAuth && currentUser) {
    next();
  } else {
    next();
  }
});

export default router;
